module.exports = __webpack_public_path__ + "img/button-bg2.ce650cec.png";